/**
 * NB: To actually add a route to our navigation layer, then it should first be
 * added to @pm2/api/api.sitecore/descriptor.user-area.
 *
 * This object is exclusively a convenience object, exposing the available
 * user-area paths to intellisenseæ
 */
const Routes = {
  PORTALS: "fagportaler",
  FAVOURTIES: "favoritter",
  ENTRIES: "besvarelser",
  COURSES: "forloeb",
  TEAMS: "hold",
  SPEECH: "oplaesning",
  FONT: "skrifttype",
  SUPPORT: "teknisk-support"
};

export { Routes };
//# sourceMappingURL=const.routes.js.map
